import React, {useMemo} from "react";
import {CheckoutProcessStatusType, useCheckoutForm} from "./hooks/useCheckoutForm";
import {Stack, Typography, Button} from "@mui/material";
import {CheckIcon, XIcon} from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { AppConfigFields, ContactInfoFields } from "../../types/appConfigEntities";
import {
    WhatsApp
} from "@mui/icons-material";

export const CheckoutFinishedResult: React.FC = () => {
  const { processStatus } = useCheckoutForm();
  const navigate = useNavigate();
  
  const { Icon, title, description, color } = useMemo(() => {
    
    switch (processStatus.type) {
      case CheckoutProcessStatusType.FinishedSuccessfully:
        return {
          Icon: CheckIcon,
          title: 'Pedido registrado correctamente!',
          description: processStatus.description,
          color: '#008547'
        }

      case CheckoutProcessStatusType.FinishedWithError:
        return {
          Icon: XIcon,
          title: 'No pudimos procesar su compra',
          description: processStatus.description,
          color: '#d32f2f'
        }
        
      case CheckoutProcessStatusType.InProgress:
      default:
        return {
          Icon: null,
          title: null,
          description: '',
          color: ''
        }
    }
  }, [processStatus]);

  const handleBackToStore = () => {
    navigate('/');
    };

    const contactInfo = window.APP_CONFIG[AppConfigFields.ContactData];
    const whatsappNumber = contactInfo?.whatsapp?.replace(/\D/g, '');
    const w = (str: string) =>
        str.replace(/\n/g, '%0A');


    const rawMessage = [
        "Hola! Quería consultar por mi pedido.",
        "",
        `* Número de orden: #${processStatus.orderNumber}`,
        `* Nombre: ${processStatus.customerName}`,
        `* Email: ${processStatus.customerEmail}`,
        `* Teléfono: ${processStatus.customerPhone}`,
        processStatus.deliveryAddress ? `* Dirección: ${processStatus.deliveryAddress}` : "",
        `* Código Postal: ${processStatus.zipCode}`,
        "",
        "Gracias!"
    ].filter(Boolean).join("\n");



    const whatsappMessage = encodeURIComponent(rawMessage);

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
  
  return (
    <Stack spacing={1.5} alignItems={'center'}>
      {
        !!Icon &&
          <Icon color={color} size={30} />
      }

      {
        title &&
          <Typography fontFamily={'inherit'}
                      fontSize={'18px'}
                      fontWeight={600} 
                      color={color}
          >
            {title}
          </Typography>
      }

          {processStatus.type === CheckoutProcessStatusType.FinishedSuccessfully &&
              processStatus.orderNumber && (
                  <Typography
                      fontFamily={'inherit'}
                      fontSize={'28px'}
                      fontWeight={700}
                      color={color}
                      sx={{ mt: 1 }}
                  >
                      Número de orden: #{processStatus.orderNumber}
                  </Typography>
              )
          }

          {/* Texto secundario abajo */}
          {description && (
              <Typography
                  variant={'subtitle1'}
                  fontFamily={'inherit'}
                  fontSize={'15px'}
                  fontWeight={300}
                  sx={{ opacity: .8, textAlign: 'center', mt: 1 }}
              >
                  {description}
              </Typography>
          )}

      {
        processStatus.type === CheckoutProcessStatusType.FinishedSuccessfully &&
          <Typography variant={'body2'}
                      fontFamily={'inherit'}
                      fontSize={'14px'}
                      fontWeight={300}
                      sx={{ opacity: .7, textAlign: 'center', mt: 1 }}
          >
            Para consultas o gestión de pago, comunicate por WhatsApp a 11 26285292
          </Typography>
      }

          {(processStatus.type === CheckoutProcessStatusType.FinishedSuccessfully ||
              processStatus.type === CheckoutProcessStatusType.FinishedWithError) && (
                  <Stack direction="row" spacing={2} sx={{ mt: 4 }}>

                      <Button
                          variant="contained"
                          onClick={() => window.open(whatsappUrl, '_blank')}
                          startIcon={<WhatsApp />}
                          sx={{
                              backgroundColor: '#25D366',
                              '&&': { color: '#fff' },
                              fontFamily: 'inherit',
                              fontWeight: 500,
                              textTransform: 'none',
                              py: 1.5,
                              '&:hover': { backgroundColor: '#1ebe5d' }
                          }}
                      >
                          CONTACTAR POR WHATSAPP
                      </Button>

                      <Button
                          variant="contained"
                          onClick={handleBackToStore}
                          sx={{
                              backgroundColor: '#000',
                              '&&': { color: '#fff' },
                              fontFamily: 'inherit',
                              fontWeight: 500,
                              textTransform: 'none',
                              py: 1.5,
                              '&:hover': { backgroundColor: '#333' }
                          }}
                      >
                          VOLVER A LA TIENDA
                      </Button>
                  </Stack>
              )}
    </Stack>
  )
}














